/* eslint-disable */
function extractOption(fieldOptions, key) {
    let placeholder
    switch (key) {
        case 'SRS':
            placeholder = "Series"
            break
        case 'EMO':
            placeholder = "Emotion"
            break
        case 'HS':
            placeholder = "Intensity"
            break
        case 'BDY':
            placeholder = "Primary Body Part"
            break
        case 'MDE':
            placeholder = "Mode"
            break
        case 'BFT':
            placeholder = "Benefit"
            break
        case 'LOC':
            placeholder = "Location"
            break
        case 'LVL':
            placeholder = "Level"
            break
        case 'CLG':
            placeholder = "Colour Grade"
            break
        case 'RV':
            placeholder = "Review"
            break
        case 'RC':
            placeholder = "Rough Cut"
            break
        case 'FC':
            placeholder = "Final Cut"
            break
        case 'TM':
            placeholder = "Timer"
            break
        case 'AUDIO':
            placeholder = "Audio"
            break
        case 'STRETCHFLOW_MDE':
            placeholder = "Mode"
            break

        default:
            placeholder = ""
    }
    // if (!fieldOptions[key]) {
    //     return [{ value: null, text: `Select a ${placeholder}` }]
    // }

    if (fieldOptions[key]) {
        if (key === 'LVL') {
            return [...fieldOptions[key].map(option => {
                return {
                    value: option.value,
                    text: option.value
                }
            })].filter(option => option.text !== 'All')
        }

        if (key === 'SRS') {
            return [{ value: null, text: `Type or Select Series` }, ...fieldOptions[key].map(option => {
                return {
                    value: option.id,
                    text: option.label
                }
            })]
        }
        // { value: null, text: `Select a ${placeholder}` },
        return [...fieldOptions[key].map(option => {
            return {
                value: option.id,
                text: option.label
            }
        })]
    }
    return []
}
export default {

    fieldOptionsChunked: (state) => {
        return state.fieldOptions
    },
    seriesOptions: (state) => {
        console.log()
        return extractOption(state.fieldOptions, 'SRS')
    },
    emotionsOptions: (state) => {
        return extractOption(state.fieldOptions, 'EMO')
    },
    intensityOptions: (state) => {
        let intensity = extractOption(state.fieldOptions, 'HS')
        let options = [];
        //GET N/A VALUE
        intensity.forEach((option) => {
            if (option.text == "N/A" || option.text == "n/a") {
                options.push(option);
            }
        });
        //REMOVED N/A VALUE
        intensity.forEach((option) => {
            if (option.text != "N/A" && option.text != "n/a") {
                options.push(option);
            }
        });
        return options;
    },
    bodyPartsOptions: (state) => {
        return extractOption(state.fieldOptions, 'BDY')
    },
    modeOptions: (state) => {
        return extractOption(state.fieldOptions, 'MDE')
    },
    sfModeOptions: (state) => {
        return extractOption(state.fieldOptions, 'STRETCHFLOW_MDE')
    },
    sfEmotionOptions: (state) => {
        return extractOption(state.fieldOptions, 'STRETCHFLOW_EMO')
    },
    sfIntensityOptions: (state) => {
        return extractOption(state.fieldOptions, 'STRETCHFLOW_HS')
    },
    benefitsOptions: (state) => {
        return extractOption(state.fieldOptions, 'BFT')
    },
    locationsOptions: (state) => {
        return extractOption(state.fieldOptions, 'LOC')
    },
    levelOptions: (state) => {
        return extractOption(state.fieldOptions, 'LVL')
    },
    coloursOptions: (state) => {
        return state.fieldOptions['CL'] ? state.fieldOptions['CL'] : []
    },
    cautionsOptions: (state) => {
        return extractOption(state.fieldOptions, 'CAU')
    },
    reviewOptions: (state) => {
        return extractOption(state.fieldOptions, 'RV')
    },
    roughCutOptions: (state) => {
        return extractOption(state.fieldOptions, 'RC')
    },
    finalCutOptions: (state) => {
        return extractOption(state.fieldOptions, 'FC')
    },
    timerOptions: (state) => {
        return extractOption(state.fieldOptions, 'TM')
    },
    colourGradeOptions: (state) => {
        return extractOption(state.fieldOptions, 'CLG')
    },
    audioOptions: (state) => {
        return extractOption(state.fieldOptions, 'AUDIO')
    },
    warmupsOptions: (state) => {
        return [{ value: null, text: `Select a Warmup` }, ...state.warmupsOptions.map(option => {
            return {
                value: option.id,
                text: option.working_title
            }
        })]
    },
    stretchFlowsOptions: (state) => {
        return [{ value: null, text: `Select a Stretch Flow` }, ...state.stretchFlowsOptions.map(option => {
            return {
                value: option.id,
                text: option.working_title
            }
        })]
    },
    sidebarOpened: (state) => {
        return state.sidebarOpened
    },
    currentActivity: (state) => {
        return state.currentActivity
    },
    equipmentCategoryList: (state) => {
        return state.equipmentsCategories
    },
    equipmentsCategories: (state) => {
        if (!state.equipmentsCategories) return []
        const equipmentCategories = state.equipmentsCategories
        const activity = state.currentActivity
        return equipmentCategories.map(category => {
            const equipments = category.equipments.map(equipment => {
                return equipment.id
            })
            return {
                ...category,
                selected: activity.selected_equipments.filter(selected_equipment => {
                    if (equipments.includes(selected_equipment.equipment) && selected_equipment.selected_option != 'no')
                        return selected_equipment
                })
            }
        })
    },
    selectedEquipments: (state) => {
        /* TODO - Need to reduce */
        if (!state.equipmentsCategories) return []
        let equipmentCategories = state.equipmentsCategories
        const activity = state.currentActivity
        equipmentCategories = equipmentCategories.map(category => {
            const equipments = category.equipments.map(equipment => {
                return equipment.id
            })


            return {
                ...category,
                selected: activity.selected_equipments.filter(selected_equipment => {
                    if (equipments.includes(selected_equipment.equipment) && selected_equipment.selected_option != 'no')
                        return selected_equipment
                })
            }
        })


        return equipmentCategories.map((item) => {
            return {
                ...item,
                selected: item.selected.map((selected) => {
                    return {
                        ...selected,
                        label: item.equipments
                            .filter((equipment) => equipment.id === selected.equipment)
                            .map((equipment) => equipment.label)
                            .join(', ')
                    };
                })
            };
        })

    },
    currentEquipment: (state) => {
        return state.currentEquipment
    },
    workoutsList: (state) => {
        return state.workouts
    },
    startTabValidationRules: (state) => {
        return {
            "series": {
                presence: true,
            },
            "working_title": {
                presence: true,
                length: {
                    minimum: 1,
                    message: "can't be blank",
                }
            },
            "working_title": {
                presence: true,
                length: {
                    maximum: 250,
                }
            },
            "colour": {
                presence: true,
            },
        }
    },
    startTabErrors: (state) => {
        return state.currentActivityState ? state.currentActivityState.startTab : ''
    },
    musicTabValidationRules: (state) => {
        return {
            "spotify_playlist_name": {
                presence: true,
                length: {
                    minimum: 1,
                    message: "can't be blank",
                }
            },
            "spotify_playlist_link": {
                presence: true,
                length: {
                    minimum: 1,
                    message: "can't be blank",
                }
            },
        }
    },
    musicTabErrors: (state) => {
        return state.currentActivityState ? state.currentActivityState.musicTab : ''
    },
    notesOpened: (state) => {
        return state.notesOpened
    },
    approvalOpened: (state) => {
        return state.approvalOpened
    },
    approvalStatus: (state) => {
        return state.approvalStatus
    },
    currentFlag: (state) => {
        return state.activeFlag
    },
    flagsList: (state) => {
        return state.flags
    },
    currentDataList: (state) => {
        return state.currentDataList ? state.currentDataList : []
    },
    saving: (state) => {
        return state.saving
    },

    render: (state) => {
        if (state.currentActivity.render) {
            return state.currentActivity.render
        }
        return state.render
    },
    pre_production: (state) => {
        if (state.currentActivity.pre_production) {
            return state.currentActivity.pre_production
        }
        return state.pre_production
    },
    post_production: (state) => {
        if (state.currentActivity.post_production) {
            return state.currentActivity.post_production
        }
        return state.post_production
    },
    currentPaginationPage: (state) => {
        return state.currentPaginationPage
    },
    currentWarmup: (state) => {
        return state.currentWarmup
    },
    currentStretchFlow: (state) => {
        return state.currentStretchFlow
    },
    currentVideos: (state) => {
        return state.currentVideos
    },
    userList: (state) => {
        return state.userList
    },
    userFieldOption: (state) => {
        return [...state.userList.map(option => {
            return {
                value: option.id,
                text: option.profile
            }
        })]
    },

    savingForm: (state) => {
        return state.savingForm
    },
    savingErrorMessage: (state) => {
        return state.savingErrorMessage
    },

    tabStatus: (state) => {
        return state.tabStatus
    },

    activityCurrentTab: (state) => {
        return state.activityCurrentTab
    },

    preloader: (state) => {
        return state.preloader
    },
    journeyList: (state) => {
        return state.journeyList
    },
    journeyReport: (state) => {
        return state.journeyReport
    },

}